/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Moon = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    viewBox="0 0 182 92"
    ref={ref}
    css={{
      color: "#F4F6F8",
      height: "92px",
      width: "182px",
    }}
    {...props}
  >
    <g fill="none" fillRule="evenodd" transform="translate(1 1)">
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M90 0c49.706 0 90 40.294 90 90H0C0 40.294 40.294 0 90 0z"
      />
      <path fill="#74B0F4" d="M92 64h7.636v6.545H92z" />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M98.258 84.244a82.355 82.355 0 0 1 17.265 3.101m-47.046.178a82.256 82.256 0 0 1 18.634-3.329M92 87.523V64h18.818v12.545H92m0-6.272h18.818"
      />
      <path
        fill="#F18686"
        d="M70.154 46.752h3.028a3.138 3.138 0 0 1 3.136 3.136v1.464c0 1.05.523 2.03 1.397 2.612l2.003 1.336a2.927 2.927 0 0 1 0 4.876l-5.282 3.519c-3.563-2.342-5.527-5.15-5.89-8.422-.364-3.273.172-6.113 1.608-8.52z"
      />
      <path
        fill="#F18686"
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M91.891 46.752h-1.463a3.136 3.136 0 0 0-2.802 4.54c.893 1.785 1.098 1.881 1.65 2.203l3.972 2.38"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M84.067 65.196c-6.722 1.681-13.532-2.407-15.213-9.129-1.681-6.722 2.406-13.532 9.129-15.213 6.722-1.681 13.532 2.406 15.213 9.129a12.56 12.56 0 0 1-.109 6.49"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M70.154 46.752h3.028a3.138 3.138 0 0 1 3.136 3.136v1.464c0 1.05.523 2.03 1.397 2.612l2.003 1.336a2.927 2.927 0 0 1 0 4.876l-5.282 3.519M99.84 64v6.273"
      />
      <path
        fill="#CAD0D8"
        d="M53 31c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm61 12c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm40 34c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137z"
      />
      <circle cx={45.5} cy={57.5} r={1.5} fill="#CAD0D8" />
      <circle cx={32.5} cy={34.5} r={1.5} fill="#CAD0D8" />
      <circle cx={17.5} cy={79.5} r={1.5} fill="#CAD0D8" />
      <circle cx={92.5} cy={10.5} r={1.5} fill="#CAD0D8" />
      <circle cx={78.5} cy={27.5} r={1.5} fill="#CAD0D8" />
      <circle cx={123.5} cy={16.5} r={1.5} fill="#CAD0D8" />
      <circle cx={134.5} cy={35.5} r={1.5} fill="#CAD0D8" />
      <circle cx={163.5} cy={64.5} r={1.5} fill="#CAD0D8" />
      <circle cx={138.5} cy={61.5} r={1.5} fill="#CAD0D8" />
      <g transform="translate(100 24)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(64 12)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(125 77)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(150 39)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(43 75)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(21 55)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
    </g>
  </svg>
));
